'use-client';
import * as React from 'react';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { BasicContainer } from '../../shared/BasicContainer';
import styles from './RectangleAreaAfterScroll.scss';

const RectangleAreaAfterScroll: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return <BasicContainer ref={ref} {...props} classes={styles} />;
};

export default React.forwardRef(RectangleAreaAfterScroll);
